<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.tj" @click="handleCreate">添加</el-button>
        <!-- <el-button size="small" type="primary" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getPurchaseClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="tableData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip > <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template></el-table-column>
          <el-table-column prop="gysbm" :label="lable.gysbm" width="120">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.gysbm }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="gysmc" :label="lable.gysmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="gysxz" :label="lable.gysxz" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qygm" :label="lable.qygm" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scfwyznl" :label="lable.scfwyznl" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-rate v-model="scope.row.scfwyznl" style="width:100%" :disabled="true" show-text :texts="pj"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="zlrztx" :label="lable.zlrztx" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-rate v-model="scope.row.zlrztx" style="width:100%" :disabled="true" show-text :texts="pj"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="gyspj" :label="lable.gyspj" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-rate v-model="scope.row.gyspj" style="width:100%" :disabled="true" show-text :texts="pj"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="nd" :label="lable.nd" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="gysbm" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="updateClick(scope.row)" v-if="show.xg" type="text" size="small">更改</el-button>
              <el-button @click="deleteEvalue(scope.row)" v-if="show.sc" type="text" size="small">删除</el-button>
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:15px">
        <el-pagination @size-change="handleSizeChange()" @current-change="handleCurrentChange()"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total"
          style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------上传评价弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" title="上传评价" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="130px"
        style="width: 80%; margin-left:5%;">
        <el-form-item :label="lable.gysbm" prop="gysbm">
          <el-input :placeholder="'请输入' + lable.gysbm" v-model="questionForm.gysbm" />
        </el-form-item>
        <el-form-item :label="lable.gysmc" prop="gysmc">
          <el-select style="width: 100%" v-model="questionForm.gysmc" filterable allow-create default-first-option
            :placeholder="'请选择' + lable.gysmc">
            <el-option v-for="item in companyOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.gysxz" prop="gysxz">
          <el-input :placeholder="'请输入' + lable.gysxz" v-model="questionForm.gysxz" />
        </el-form-item>
        <el-form-item :label="lable.qygm" prop="qygm">
          <el-input :placeholder="lable.qygm" v-model="questionForm.qygm" />
        </el-form-item>
        <el-form-item :label="lable.scfwyznl" prop="scfwyznl">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.scfwyznl" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.zlrztx" prop="zlrztx">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.zlrztx" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.gyspj" prop="gyspj">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.gyspj" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.nd" prop="nd">
          <el-date-picker v-model="questionForm.nd" :picker-options="pickerOptions0" disabledDate value-format="yyyy"
            type="year" placeholder="请选择">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" v-preventReClick size="small" type="success"
          @click="submitUpload">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------------------------------------更改上传评价弹框------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" title="更改评价" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="130px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.gysbm" prop="gysbm">
          <el-input :placeholder="'请输入' + lable.gysbm" v-model="questionForm.gysbm" />
        </el-form-item>
        <el-form-item :label="lable.gysmc" prop="gysmc">
          <el-select style="width: 100%" v-model="questionForm.gysmc" filterable allow-create default-first-option
            :placeholder="'请选择' + lable.gysmc">
            <el-option v-for="item in companyOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.gysxz" prop="gysxz">
          <el-input :placeholder="'请输入' + lable.gysxz" v-model="questionForm.gysxz" />
        </el-form-item>
        <el-form-item :label="lable.qygm" prop="qygm">
          <el-input :placeholder="lable.qygm" v-model="questionForm.qygm" />
        </el-form-item>
        <el-form-item :label="lable.scfwyznl" prop="scfwyznl">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.scfwyznl" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.zlrztx" prop="zlrztx">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.zlrztx" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.gyspj" prop="gyspj">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.gyspj" style="width:100%" show-text :texts="pj"> </el-rate>
          </div>
        </el-form-item>

        <el-form-item :label="lable.nd" prop="nd">
          <el-date-picker v-model="questionForm.nd" :picker-options="pickerOptions0" format="yyyy" type="year"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" v-preventReClick type="success"
          @click="updateEvaluate">更改</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------------------------------------评价详情弹框------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible2" title="评价详情" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="130px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.gysbm" prop="gysbm">
          <el-input :readonly="true" v-model="questionForm.gysbm" />
        </el-form-item>
        <el-form-item :label="lable.gysmc" prop="gysmc">
          <el-input :readonly="true" v-model="questionForm.gysmc" />
        </el-form-item>
        <el-form-item :label="lable.gysxz" prop="gysxz">
          <el-input :readonly="true" v-model="questionForm.gysxz" />
        </el-form-item>
        <el-form-item :label="lable.qygm" prop="qygm">
          <el-input :readonly="true" v-model="questionForm.qygm" />
        </el-form-item>
        <el-form-item :label="lable.scfwyznl" prop="scfwyznl">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.gyspj" style="width:100%" show-text :disabled="true" :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.zlrztx" prop="zlrztx">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.gyspj" style="width:100%" show-text :disabled="true" :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.gyspj" prop="gyspj">
          <div style="float:left;margin-top: 10px;">
            <el-rate v-model="questionForm.gyspj" style="width:100%" show-text :disabled="true" :texts="pj"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item :label="lable.nd" prop="nd">
          <el-input :readonly="true" v-model="questionForm.nd" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  findAllPurchaseEvaluate,
  addPurchaseEvaluate,
  updatePurchaseEvaluate,
  deletePurchaseEvaluate,
  findAllCorporation,
  findByModule

} from "../../api/api";

export default {
  name: "Evaluate",
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      deviceInfo: {
        content: '',
        date: []
      },
      show: {
        tj: false,
        sc: false,
        xg: false,
      },
      pj: ["非常差",
        "差",
        "一般",
        "好",
        "非常好"
      ],
      lable: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      questionForm: {},
      companyOptions: []
    };
  },
  methods: {
    //点击跳转
    onClick(row) {
      this.questionForm = row;
      this.dialogFormVisible2 = true;
    },
    cancel() {
      this.dialogFormVisible = false;
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
      this.getPurchase();
    },
    findCompany() {
      findAllCorporation().then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyOptions = data
        }
      });
    },
    updateEvaluate() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      updatePurchaseEvaluate(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.getPurchase();
          this.questionForm = {};
          this.dialogFormVisible1 = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    updateClick(row) {
      this.questionForm = {};
      this.questionForm = row;
      this.dialogFormVisible1 = true;
      this.findCompany();
    },
    selectClick(row) {
      this.questionForm = {};
      this.questionForm = row;
      this.dialogFormVisible2 = true;
    },
    deleteEvalue(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        deletePurchaseEvaluate(map).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.getPurchase();
            this.$message({
              message: "删除成功",
              type: "success"
            });
            // debugger
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    handleCreate() {

      this.questionForm = {};
      this.$set(this.questionForm, "nd", this.timeUtil.timeFormat(new Date()).slice(0, 4))
      this.dialogFormVisible = true;
      this.findCompany();
    },
    submitUpload() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      addPurchaseEvaluate(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.getPurchase();
          this.questionForm = {};
          this.dialogFormVisible = false;
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    getPurchaseClick(){
      this.pageIndex=1
      this.getPurchase()
    },
    //查找资料信息
    getPurchase() {
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
      };
      findAllPurchaseEvaluate(map).then(datas => {
        let { data, status, message } = datas;
        // debugger
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.tableData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
          // debugger
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    findLable() {
      findByModule("采购管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.getPurchase();
    // this.findCompany();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "72") {
        this.show.tj = true;
      }
      if (i == "73") {
        this.show.xg = true;
      }
      if (i == "74") {
        this.show.sc = true;
      }
    })
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}

.el-input {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Evaluate.vue